import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetListAdmin} from '../../store/thunk/setGetListAdmin';
import AdminView from '../../components/admin';
import TemplatePage from '../../../components/templatePage';

const Admin = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetListAdmin())
    }, [])

    const list = useSelector((state) => state.adminMobile.list);

    return (
        <TemplatePage
            title="Список администраторов"
        >
            {
                list.map((item, key, array) => <AdminView keys={key} login={item.login} length={array.length}/>)
            }
        </TemplatePage>
    )
}

export default Admin;